import React, { useState } from "react";
import "./PinUpdate.css";

import CustomInputField from "../../../Components/Shared/CustomInputField/CustomInputField";
import OtpInput from "../../../Components/Shared/OtpInput/OtpInput";

import { usePinUpdateStatics } from "../../../hooks/usePinUpdateStatics";

import PinUpdateAuthHeader from "../../../Components/Auth/PinUpdateAuthHeader";
import { useDispatch } from "react-redux";
import { showCustomSweetAlert } from "../../../Redux/customSweetAlertSlice";

import { setInnerLoaderFalse, setInnerLoaderTrue } from "../../../Redux/loaderSlice";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { createPortal } from "react-dom";

import { motion } from "framer-motion";
import { rootUrl } from "../../../App";
import PinUpdateSuccess from "./PinUpdateSuccess";
import { useThemeColor } from "../../../hooks/useThemeColor";

const whatsApp = process.env.PUBLIC_URL + "/Assets/Images/Icons/SharedIcons/whatsapp.png";

const PinUpdate = () => {
    const staticOrigin = `betkingly`;

    const { sliderImgList } = usePinUpdateStatics();

    const dispatch = useDispatch();
    const { colorMode } = useThemeColor();


    const initialState = {
        credential: "",
        password: "",
        request_origin: staticOrigin

    };
    const [loginFormData, setLoginFormData] = useState(initialState);
    const [token, setToken] = useState(null);

    const updateLoginFormData = (e) => {
        let newUser = { ...loginFormData };
        let list = (e.target.value).split(" ");
        if (list?.length > 1) {
            dispatch(showCustomSweetAlert({
                type: "error",
                message: `Space is not allowed`
            }));
        } else {
            if (e.target.name === "credential") {
                newUser[e.target.name] = e.target.value.toLowerCase();
            }
            if (e.target.name === "password") {
                newUser[e.target.name] = e.target.value;
            }

            setLoginFormData({ ...newUser });
        }
    }

    const submitLogin = async (e) => {
        e.preventDefault();
        dispatch(setInnerLoaderTrue());
        try {
            let payload = { ...loginFormData };

            const response = await fetch(`${rootUrl}/auth/exist-user/login/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            let data = await response.json();
            // console.log(data);
            if (data?.errors || data?.login_error) {
                dispatch(showCustomSweetAlert({
                    type: "error",
                    message: `${data.errors || data.login_error}`
                }));
                return;
            }
            if (data?.token) {
                setToken(data?.token);
                setLoginFormData(initialState);
                return;
            }

        } catch (error) {
            console.log(error);
        } finally {
            dispatch(setInnerLoaderFalse());
        }
    }


    // change pin

    const [newPin, setNewPin] = useState("");
    const [confirmPin, setConfirmPin] = useState("");

    const onChangeNewPin = (value) => {
        setNewPin(value);
    };

    const onChangeConfirmPin = (value) => {
        setConfirmPin(value);
    };

    const updatePinFunction = (e) => {
        e.preventDefault();

        if (newPin !== confirmPin) {
            dispatch(showCustomSweetAlert({
                type: "error",
                message: `PIN didn't match!`
            }));
            return;
        }
        if (!token) {
            dispatch(showCustomSweetAlert({
                type: "error",
                message: `Unauthorised!`
            }));
            return;
        }

        let sendData = {
            pin: newPin,
            token: token,
            request_origin: staticOrigin
        };

        fetch(`${rootUrl}/auth/exist-user/register/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(sendData)
        })
            .then(async res => {
                if (!res.ok) throw res;
                else return await res.json();
            })
            .then(data => {
                // console.log(data);
                if (data?.status === "ok") {
                    showPinUpdateSuccessSweetAlert2({
                        type: "success",
                        message: `${data?.message && `Your PIN Updated Successfully`}`,
                        extra: `pin-update`,
                        credential: {
                            username: data?.data?.username,
                            pin: data?.data?.pin,
                        }
                    });
                    setNewPin("");
                    setConfirmPin("");
                    return;
                }
                if (data?.status === "failed") {
                    dispatch(showCustomSweetAlert({
                        type: "error",
                        message: `${data?.errors?.username || data?.errors}`
                    }));
                    return;
                }
            })
            .catch(err => {
                console.log(err);
            })
            .finally(
            // () => dispatch(setInnerLoaderFalse());
        )
    }

    // modal

    const [pinUpdateSuccessModal, setPinUpdateSuccessModal] = useState({
        visible: false,
        extra: null
    });

    const openPinUpdateSuccessModal = (extra, credential) => {
        // console.log(item);
        setPinUpdateSuccessModal({
            visible: true,
            extra: extra,
            credential: credential
        });
    };

    const closePinUpdateSuccessModal = () => {
        setPinUpdateSuccessModal({
            visible: false,
            extra: null,
        });
        // navigate("/login");
        window.open(`https://glo65.com/credential`, "_parent");
    }

    const MySwal = withReactContent(Swal);

    const showPinUpdateSuccessSweetAlert2 = (data) => {
        // console.log(data);

        MySwal.fire({
            title: <p style={{
                color: "var(--light-green)"
            }}>
                {data?.message || `N/A`}
            </p>,
            icon: data?.type,
            showConfirmButton: false,
            background: (colorMode === "dark") ? "var(--dark)" : (colorMode === "light") ? "var(--white)" : "var(--red)",
            showCloseButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            closeButtonHtml: "&times;",
            didOpen: () => openPinUpdateSuccessModal(data?.extra, data?.credential),
            didClose: () => closePinUpdateSuccessModal(),
        }).then(() => {
        })
    }

    return (
        <>
            <motion.div
                initial={{ opacity: 0, x: "-50%" }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: "50%" }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
            >
                <div className="credential full-height-page">

                    <PinUpdateAuthHeader sliderImgList={sliderImgList} />

                    {
                        (!token) &&
                        <div className="row gx-0 py-0 d-flex justify-content-center align-items-center" >
                            <div className="col-11">
                                <div className="row gx-0 d-flex justify-content-center align-items-center py-5">
                                    <div className="col-9 page-title-underline">
                                        <h1 className="text-center text-uppercase fs-5 mb-0">{"Login"}</h1>
                                    </div>
                                </div>
                                <div className="row gx-0 gy-3 d-flex justify-content-center align-items-center pb-0">
                                    <div className="col-12">
                                        <form
                                            onSubmit={submitLogin}
                                            className="auth-form"
                                        >
                                            <CustomInputField type="text" name="credential" label="Username / Email Address"
                                                value={loginFormData.credential || ""} func={updateLoginFormData}
                                            />
                                            <CustomInputField type="password" name="password" label="Enter your password"
                                                value={loginFormData.password || ""} func={updateLoginFormData}
                                            />
                                            <button className="text-uppercase btn golden-button w-100 rounded my-3">
                                                {/* <RiLoginCircleLine className="me-2 mb-1" size={"16"} /> */}
                                                Login</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div >
                    }

                    {
                        (token) &&
                        <div className="change-pin">

                            <div className="row gx-0 py-0 d-flex justify-content-center align-items-center">
                                <div className="col-11">
                                    <div className="row gx-0 d-flex justify-content-center align-items-center py-5">
                                        <div className="col-9 page-title-underline">
                                            <h1 className="text-center text-uppercase fs-5 mb-0">{"Update your PIN"}</h1>
                                        </div>
                                    </div>
                                    <div className="row gx-0 py-3 d-flex justify-content-center align-items-center">
                                        <div className="col-12">
                                            <form
                                                onSubmit={updatePinFunction}
                                                className="auth-form"
                                            >
                                                <p className="mb-0 text-start">{"Enter your new PIN : "}</p>
                                                <div className="mb-2">
                                                    <OtpInput value={newPin} valueLength={6} onChange={onChangeNewPin} />
                                                </div>

                                                <p className="mb-0 text-start">{"Confirm PIN : "}</p>
                                                <div className="mb-2">
                                                    <OtpInput value={confirmPin} valueLength={6} onChange={onChangeConfirmPin} />
                                                </div>

                                                <button className="text-uppercase btn golden-button w-100 rounded my-3">
                                                    Confirm</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div>
                    }
                    <div className="my-3">
                        <h6 className="text-center">{"Customer Support"}</h6>
                        <p>
                            <small
                                className="fw-bold red-text"
                            >
                                {`Contact with our admin if you are facing any issues.`}
                            </small>
                        </p>
                        <div className="d-flex justify-content-center align-items-center">
                            <a
                                className="pointer d-flex justify-content-center align-items-center"
                                href={`https://wa.me/+447451246725`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={whatsApp} alt="social" width={"30"} height={"30"} />
                            </a>
                        </div>
                    </div>
                    {
                        (pinUpdateSuccessModal?.visible) &&
                        createPortal(
                            <PinUpdateSuccess
                                data={pinUpdateSuccessModal}
                                close={closePinUpdateSuccessModal}
                            />,
                            Swal.getHtmlContainer() || document.body
                        )
                    }
                </div >
            </motion.div>
        </>
    );
};

export default PinUpdate;